import { themes } from '@chegg-ui/theme';
// To keep consistency Export this from avatar component and use here
export var avatarSizes = {
  xl: 120,
  lg: 88,
  md: 64,
  sm: 48,
  xs: 32,
  xxs: 24
};
export var avatarCircleContentSpace = {
  xl: themes.horizon.spacing.lg,
  lg: themes.horizon.spacing.lg,
  md: themes.horizon.spacing.md,
  sm: themes.horizon.spacing.md,
  xs: themes.horizon.spacing.xs,
  xxs: themes.horizon.spacing.xs
};
export var shimmerBookCoverConfig = {
  small: {
    height: '4.375rem',
    width: '3.25rem'
  },
  medium: {
    height: '6.75rem',
    width: '5rem'
  },
  large: {
    height: '8rem',
    width: '6rem'
  },
  xlarge: {
    height: '14rem',
    width: '10.5rem'
  }
};